import { formatCurrencyInputOnChangeWithoutDecimals } from '@fruitful/fruitils';

export const formatCentsForDollarInput = (
    cents: number | null | undefined,
): string => {
    if (cents == null || cents === 0) return '';
    return formatCurrencyInputOnChangeWithoutDecimals(
        '$ ',
        String(Math.floor(cents / 100)),
    );
};

export const parseDollarInputToCents = (input: string): number | null => {
    const cleaned = input.replace(/[^0-9]/g, '');
    if (!cleaned) return null;
    return parseInt(cleaned, 10) * 100;
};

export const percentToInputString = (
    decimal: number | null | undefined,
): string => {
    if (decimal == null || decimal <= 0) return '';
    const whole = Math.round(decimal * 100);
    return whole > 0 ? `${whole} %` : '';
};

export const parsePercentInputToDecimal = (input: string): number | null => {
    const cleaned = input.replace(/\s*%\s*/g, '');
    if (!cleaned) return null;
    const parsed = parseInt(cleaned, 10);
    return Number.isNaN(parsed) ? null : parsed / 100;
};
